import { Box } from '@mui/material';
import { useFormContext } from 'react-hook-form';

import NumberField from 'components/number-field';
import { UpdateScenarioFinancialDataInput } from 'views/bluviu-nutrition/features/scenarios-v2/types/update-scenario-financial-data-input.type';
import { useIntl } from 'react-intl';

const SalesPriceSection: React.FC = () => {
  const { control } = useFormContext<UpdateScenarioFinancialDataInput>();
  const intl = useIntl();

  const salesPriceFields = [
    {
      label: '0-1 kg fish',
      name: 'salesPricePerKgUnder1Kg',
    },
    {
      label: '1-2 kg fish',
      name: 'salesPricePerKg1To2Kg',
    },
    {
      label: '2-3 kg fish',
      name: 'salesPricePerKg2To3Kg',
    },
    {
      label: '3-4 kg fish',
      name: 'salesPricePerKg3To4Kg',
    },
    {
      label: '4-5 kg fish',
      name: 'salesPricePerKg4To5Kg',
    },
    {
      label: '5-6 kg fish',
      name: 'salesPricePerKg5To6Kg',
    },
    {
      label: '6+ kg fish',
      name: 'salesPricePerKgOver6Kg',
    },
  ];

  return (
    <Box display={'grid'} gridTemplateColumns={'repeat(2,1fr)'} gap={4}>
      {salesPriceFields.map((field) => (
        <NumberField
          dark
          key={field.name}
          label={field.label}
          fullWidth
          decimalScale={3}
          endAdornment="/ kg HOG"
          controller={{
            control,
            name: field.name,
            rules: {
              required: intl.formatMessage({ id: 'form.rules.required' }),
              validate: {
                greaterThanZero: (value) => (value > 0 ? true : intl.formatMessage({ id: 'form.rules.moreThanZero' })),
              },
            },
          }}
        />
      ))}
    </Box>
  );
};

export default SalesPriceSection;
